"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var react_router_dom_1 = require("react-router-dom");
var querystring_1 = __importDefault(require("querystring"));
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var TextInput_1 = __importDefault(require("../common/inputs/TextInput"));
var Button_1 = __importDefault(require("../common/buttons/Button"));
var Loading_1 = __importDefault(require("../Loading"));
var use_notification_1 = require("../../hooks/use-notification");
var Notification_1 = require("../Notification");
var apiRoutes = config_1.default.apiRoutes;
var ResetPassword = mobx_react_1.observer(function () {
    var _a = react_1.useState({}), data = _a[0], setData = _a[1];
    var apiStore = use_stores_1.useStores().apiStore;
    var busyRoutes = apiStore.data.busyRoutes;
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var parsed = querystring_1.default.parse(location.search.replace(/^\?/, ''));
    var link = parsed.link;
    var notification = use_notification_1.useNotification();
    var redirectTimerRef = react_1.useRef(null);
    react_1.useEffect(function () {
        api_1.default.resetLinks({ link: link })
            .catch(function () {
            history.replace('/login');
        });
    }, [location]);
    var changeHandler = function (e) {
        var _a;
        setData(__assign(__assign({}, data), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var submitHandler = function (e) {
        e.preventDefault();
        var error = null;
        if (data.confirmPassword && data.confirmPassword !== data.password)
            error = 'Your passwords do not match';
        if (!data.confirmPassword || data.confirmPassword.length <= 0)
            error = 'Please confirm your password';
        if (data.password && data.password.length < 8)
            error = 'Your password should be 8 characters or longer';
        if (!data.password || data.password.length <= 0)
            error = 'Please enter your password';
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: error
            });
            return;
        }
        api_1.default.resetPassword(__assign(__assign({}, data), { link: link }))
            .then(function () {
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Your password has been reset, please log in'
            });
            clearTimeout(redirectTimerRef.current);
            redirectTimerRef.current = setTimeout(function () {
                history.replace('/login');
            }, 200);
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'reset-password forgot-password', "data-busy": busyRoutes.includes(apiRoutes.RESET_LINKS) },
        react_1.default.createElement("form", { className: 'forgot-password__form', onSubmit: submitHandler },
            react_1.default.createElement("h1", null, "Reset Your Password"),
            react_1.default.createElement("p", null, "Please enter a new password."),
            react_1.default.createElement(TextInput_1.default, { type: 'password', name: 'password', value: data.password, onChange: changeHandler, placeholder: 'Password (Min 8 Characters)' }),
            react_1.default.createElement(TextInput_1.default, { type: 'password', name: 'confirmPassword', value: data.confirmPassword, onChange: changeHandler, placeholder: 'Confirm Password' }),
            react_1.default.createElement(Button_1.default, { type: 'submit', icon: busyRoutes.includes(apiRoutes.RESET_PASSWORD) ? react_1.default.createElement(Loading_1.default, null) : null, title: 'Reset Password' }, "Reset Password"))));
});
exports.default = ResetPassword;
